import { render, staticRenderFns } from "./StandardSmallBorderedButton.vue?vue&type=template&id=3a616c36&scoped=true"
import script from "./StandardSmallBorderedButton.vue?vue&type=script&lang=js"
export * from "./StandardSmallBorderedButton.vue?vue&type=script&lang=js"
import style0 from "./StandardSmallBorderedButton.vue?vue&type=style&index=0&id=3a616c36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a616c36",
  null
  
)

export default component.exports